export const navigateToHome = () => {
  window.location.replace('https://kasanak.com')
}
